import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import LoginContext from "../store/loginContext";

const AuthLayout: React.FC = () => {
  const location = useLocation();
  const loginCtx = useContext(LoginContext);

  if (!loginCtx?.isLogin) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default AuthLayout;
